module.exports = __webpack_public_path__ + "assets/6eb6a9c1de45a9f1cd8af464e8f85d61.mp3";